















import AppFooter from "./components/AppFooter.vue";
import AppHeader from "./components/AppHeader.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    AppFooter,
    AppHeader,
  },
})
export default class App extends Vue {
  showRoutes: string[] = ["VehicleDetail", "Vehicles"];

  mounted() {
    this.$vuetify.theme.dark =
      localStorage.getItem("darkMode") === "true" || false;
  }

  get theme(): string {
    return this.$vuetify.theme.dark ? "dark" : "light";
  }
}
